var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { observer } from '@formily/reactive-vue';
import { connect, h } from '@formily/vue';
import { defineComponent } from '@vue/composition-api';
import { Field as VanFormItem } from 'vant';
import { stylePrefix } from '../__builtins__/configs';
import { inputValidate } from '../input';
export var BaseFormItem = observer(defineComponent({
    name: 'FBaseFormItem',
    props: {
        label: {},
    },
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners;
        return function () {
            var _a;
            return h(VanFormItem, {
                class: (_a = {}, _a["".concat(stylePrefix, "-input-asterisk")] = attrs.asterisk, _a),
                attrs: __assign(__assign({}, attrs), props),
                on: listeners,
            }, {
                input: function () { var _a; return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots); },
            });
        };
    },
}));
export var FormItem = connect(BaseFormItem, inputValidate);
export default FormItem;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/form-item/index.js
// module id = null
// module chunks = 